import {ChangeDetectionStrategy, Component, input, output} from "@angular/core";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {Modules, SimUser} from "@models";
import {TranslatePipe} from "@ngx-translate/core";
import {SimConfigurationService, SimDeviceMappingService} from "@services";
import {Translations} from "@translations";

@Component({
	selector: "sim-header-sidenav",
	templateUrl: "./sim-header-sidenav.component.html",
	styleUrls: ["./sim-header-sidenav.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [MatIconModule, TranslatePipe, MatButtonModule],
})
export class HeaderSidenavComponent {
	// Constants
	protected readonly hasLicenseModule = SimConfigurationService.hasLicenseModule;
	protected readonly clientProperties = SimDeviceMappingService.clientProperties;
	protected readonly Modules = Modules;
	protected readonly T = Translations;

	// I/O
	readonly user = input<SimUser>();
	readonly openUserCard = output<void>();
}
